import { render, staticRenderFns } from "./submissions.datarow.vue?vue&type=template&id=46512849&scoped=true&"
import script from "./submissions.datarow.vue?vue&type=script&lang=js&"
export * from "./submissions.datarow.vue?vue&type=script&lang=js&"
import style0 from "./submissions.datarow.vue?vue&type=style&index=0&id=46512849&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46512849",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VIcon})
